/* Sofia Lark category rows: the arrows move one screenful of cards, switch off at either end,
   and disappear when every card already fits. Scrolling itself is native (touch, trackpad,
   keyboard on the focused row), so the row works without this file. */
(function () {
  'use strict';

  function init(rail) {
    if (rail.dataset.ready) return;
    rail.dataset.ready = 'true';

    var track = rail.querySelector('[data-sl-rail-track]');
    var prev = rail.querySelector('[data-sl-rail-prev]');
    var next = rail.querySelector('[data-sl-rail-next]');
    if (!track || !prev || !next) return;

    var frame = null;

    function update() {
      frame = null;
      var max = track.scrollWidth - track.clientWidth;
      if (max <= 2) {
        rail.setAttribute('data-static', '');
      } else {
        rail.removeAttribute('data-static');
      }
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
    }

    function schedule() {
      if (!frame) frame = requestAnimationFrame(update);
    }

    var card = rail.querySelector('[data-sl-rail-card]');

    function page(direction) {
      var item = track.querySelector('.sl-rail__item');
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var step = item ? item.getBoundingClientRect().width + gap : track.clientWidth;
      // Move by the number of whole cards that are visible, so a card is never left half-cut. The
      // fixed category card covers the last column, so that column does not count.
      var open = track.clientWidth - (card ? card.getBoundingClientRect().width + gap : 0);
      var whole = Math.max(1, Math.floor((open + gap) / step));
      track.scrollBy({ left: direction * whole * step, behavior: 'smooth' });
    }

    prev.addEventListener('click', function () { page(-1); });
    next.addEventListener('click', function () { page(1); });
    track.addEventListener('scroll', schedule, { passive: true });
    if ('ResizeObserver' in window) {
      new ResizeObserver(schedule).observe(track);
    } else {
      window.addEventListener('resize', schedule);
    }
    update();
  }

  function boot() {
    document.querySelectorAll('[data-sl-rail]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var rail = event.target.querySelector('[data-sl-rail]');
    if (rail) init(rail);
  });
})();
